import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { I18n } from '../helpers/i18n'; // Ensure you've imported toast

const PrivateRouteSenior = ({ component: Component, commonProps, ...rest }) => {
    const userData = localStorage.getItem('ced:user-info');
    const user = userData ? JSON.parse(userData) : null;

    return (
        <Route
            {...rest}
            render={(props) => {
                // Check mvpUserType first (for MVP users), fallback to type for backward compatibility
                const hasExplorerAccess = user && (
                    (user.mvpUserType === 'explorer' || user.mvpUserType === 'both') ||
                    (user.type === 'senior' && !user.mvpUserType) // Backward compatibility for old users
                );
                
                if (hasExplorerAccess) {
                    return <Component {...commonProps} {...props} />;
                } else {
                    // Show toast message before redirecting
                    toast.info(I18n.t('need_senior_account'), {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        className: 'toast-info-container',
                    });
                    return redirectToLogin(props);
                }
            }}
        />
    );
};

function redirectToLogin(props) {
  const historyUrl = window.location.href.replace(window.location.origin, "");
  sessionStorage.setItem('ced:previousUrl', historyUrl);
  return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
}

export default PrivateRouteSenior;
